import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';
import { useSelector } from 'react-redux';
import { isAdmin, isSales } from 'store/modules/auth/selectors';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { CrmDirectory } from './listDirectoryEntries/CrmDirectory';
import { CrmCompanyCreate } from './newCompany/CrmCompanyCreate';
import { CrmContactCreate } from './newContact/CrmContactCreate';
import { CrmCompanyEdit } from './editCompany/CrmCompanyEdit';
import { CrmContactEdit } from './editContact/CrmContactEdit';
import { CrmMyActivity } from './crmActivity/MyActivity/CrmMyActivity';
import { CrmDashboard } from './dashboard/CrmDashboard';

export interface CRMRoutingProps extends RouteComponentProps { }

export const CRMRouting = (props: CRMRoutingProps) => {
  const { dynamicParameters } = useDynamicParameters();
  const userIsAdmin = useSelector(isAdmin);
  const userIsSales = useSelector(isSales);
  const shouldShowDashboardAsDefaultPage = dynamicParameters.CRM_DASHBOARD_TEMP && (userIsAdmin || userIsSales);
  const firstPath = shouldShowDashboardAsDefaultPage ? `${props.match.path}/dashboard` : `${props.match.path}/directory`;

  return (
    <Switch>
      <Redirect exact from={props.match.path} to={firstPath} />
      {dynamicParameters.CRM_DASHBOARD_TEMP && <Route path={`${props.match.path}/dashboard`} component={CrmDashboard} />}
      <Route exact path={`${props.match.path}/directory`} component={CrmDirectory} />
      <Route exact path={`${props.match.path}/company/create`} component={CrmCompanyCreate} />
      <Route exact path={`${props.match.path}/contact/create`} component={CrmContactCreate} />
      <Route path={`${props.match.path}/company/:companyId/edit`} component={CrmCompanyEdit} />
      <Route path={`${props.match.path}/contact/:contactId/edit`} component={CrmContactEdit} />
      <Route path={`${props.match.path}/activity`} component={CrmMyActivity} />
    </Switch>
  );
};

export const RateBreakRouting = compose(withRouter)(CRMRouting);
